// Mock data for use when Builder.io API fails

import ridleyImage from "../images/ridley.png";

export const mockBikeCategories = [
  {
    id: "gravel-bike",
    name: "gravel-bike",
    data: {
      cesta: "gravel",
      nazev: "Gravel",
      popis: "Kola pro rychlou jízdu v terénu",
      obrazek: ridleyImage
    }
  },
  {
    id: "road-bike",
    name: "road-bike",
    data: {
      cesta: "road",
      nazev: "Road",
      popis: "Silniční kola pro maximální rychlost",
      obrazek: ridleyImage
    }
  },
  {
    id: "adventure-bike",
    name: "adventure-bike",
    data: {
      cesta: "adventure",
      nazev: "Adventure",
      popis: "Dobrodružná kola pro každý terén",
      obrazek: ridleyImage
    }
  },
  {
    id: "mountain-bike",
    name: "mountain-bike",
    data: {
      cesta: "mountain",
      nazev: "Mountain",
      popis: "Horská kola pro náročný terén",
      obrazek: ridleyImage
    }
  }
];

export const mockNewsArticles = [
  {
    id: "news-1",
    name: "news-1",
    data: {
      image: ridleyImage,
      tag: "Aktualita",
      title: "Nová kolekce kol Ridley",
      description: "Představujeme novou kolekci kol Ridley pro sezónu 2025. Přijďte se podívat na nejnovější modely a vyzkoušejte si je na vlastní kůži u našich prodejců."
    }
  },
  {
    id: "news-2",
    name: "news-2",
    data: {
      image: ridleyImage,
      tag: "Závody",
      title: "Úspěchy týmu Ridley",
      description: "Jezdci týmu Ridley dosáhli skvělých výsledků v letošní sezóně závodů. Gratulujeme všem a těšíme se na další úspěchy v příští sezóně."
    }
  },
  {
    id: "news-3",
    name: "news-3",
    data: {
      image: ridleyImage,
      tag: "Technologie",
      title: "Inovace v konstrukci rámů",
      description: "Nové technologie použité při výrobě rámů kol Ridley přináší vyšší pevnost a nižší hmotnost. Přijďte si vyzkoušet náš nejlehčí rám všech dob."
    }
  }
];

export const mockHomeContent = {
  id: "home-content",
  name: "home-content",
  data: {
    homeBikeProdejci1: "Prodejci Ridley",
    homeBikeProdejci2: "Najděte svého prodejce kol Ridley",
    novinkyTitle: "Novinky",
    novinkyDesc: "Aktuální články"
  }
};

export const mockBuilderData = {
  getHomeData: () => Promise.resolve(mockHomeContent),
  getNovinkyData: () => Promise.resolve(mockNewsArticles),
  getPick4Data: () => Promise.resolve(mockBikeCategories)
};
